var map = {
	"./da-DK.json": "1aee",
	"./de-DE.json": "f3cc",
	"./en-AU.json": "ddbd",
	"./en-GB.json": "495d",
	"./en-US.json": "1fa5",
	"./es-ES.json": "32db",
	"./fr-FR.json": "3f54",
	"./it-IT.json": "36c6",
	"./ja-JP.json": "a094",
	"./pt-BR.json": "74f4",
	"./pt-PT.json": "da95",
	"./zh-CN.json": "40b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f584";